import { useMemo } from "react";
import { AccountType } from "@common/constants/domains/accounting/accounts";
import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";
import { LineItemFallbackAccountType } from "@common/helpers/accounting";
import { AccountSearchCell } from "@components/spreadsheet/cells/AccountSearchCell";
import { useAccounts } from "@hooks/useAccounts";
import { BaseCellProps } from "@components/spreadsheet/cells";

interface Props extends BaseCellProps<string> {
    fallbackMode: LineItemFallbackAccountType;
}

const ALLOWED_TYPES: Partial<
    Record<LineItemFallbackAccountType, AccountType[]>
> = {
    [LineItemFallbackAccountType.billAccountsPayable]: [
        AccountType.accountsPayable,
    ],
    [LineItemFallbackAccountType.invoiceAccountsReceivable]: [
        AccountType.accountsReceivable,
    ],
};

export const ImporterAccountSearchCell = ({
    fallbackMode,
    row,
    ...props
}: Props) => {
    const entityId = (row?.entityId as number) || undefined;

    const { accounts: allAccounts } = useAccounts({
        entityId,
        ledgerBasis: AccountingLedgerBasis.accruals,
    });

    const allowedTypes = ALLOWED_TYPES[fallbackMode];
    const accounts = useMemo(() => {
        const enabled = allAccounts.filter((a) => !a.isDisabled);
        if (!allowedTypes) {
            return enabled;
        }
        return enabled.filter((a) =>
            (allowedTypes as readonly string[]).includes(a.type),
        );
    }, [allAccounts, allowedTypes]);

    return <AccountSearchCell {...props} row={row} accounts={accounts} />;
};
